import { render } from "./StaffDocumentDetailsPage.vue?vue&type=template&id=c61cbd7a"
import script from "./StaffDocumentDetailsPage.vue?vue&type=script&lang=js"
export * from "./StaffDocumentDetailsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__